import React from "react";
import { Button } from "antd";
import { useHistory } from "react-router";

export const LandingSection = (props) => {
  const {title, description, image, hideButton, titleClass} = props;
    const history = useHistory();
  return (
    <div className="landing-container-inner">
      <div className="leftSection">
        <div id="home-h1">
          <div className={titleClass ?? "H1"}>{title}</div>
        </div>
        <div id="home-h4" className="H4-home-x  full-width mt-25">
          {description}
        </div>
        {!hideButton && <div className="btn-container">
            <Button
              type="primary"
              className="black-button"
              size={"large"}
              onClick={() => history.push('/contact-us')}
            >
              Let's develop
            </Button>
        </div>}
      </div>
      <div className="rightSection">
        <img src={image} alt="sprintly-home"/>
      </div>
    </div>
  );
};
